import { Box, useMediaQuery } from '@mui/material';
import { CompoundCardProps } from '../../types/reports';
import BorderedButton from '../../components/common/buttons/BorderedButton';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';

type CompoundDetailsPaginationProps = {
  setSelectedCompoundIndex: (value: number) => void;
  setReportDescriptionLoading: (value: boolean) => void;
  sortedCompoundDataList: CompoundCardProps[];
  selectedCompoundIndex: number;
};

export const CompoundDetailsPagination = ({
  setReportDescriptionLoading,
  setSelectedCompoundIndex,
  selectedCompoundIndex,
  sortedCompoundDataList,
}: CompoundDetailsPaginationProps) => {
  const { theme } = useThemeContext();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down('md'));
  const selectPreviousCompound = () => {
    setReportDescriptionLoading(true);
    if (selectedCompoundIndex === null) {
      setSelectedCompoundIndex(0);
      return;
    }

    if (selectedCompoundIndex === 0) {
      setSelectedCompoundIndex(sortedCompoundDataList.length - 1);
      return;
    }

    setSelectedCompoundIndex(selectedCompoundIndex - 1);
  };

  const selectNextCompound = () => {
    setReportDescriptionLoading(true);
    if (selectedCompoundIndex === null) {
      setSelectedCompoundIndex(0);
      return;
    }

    if (selectedCompoundIndex === sortedCompoundDataList.length - 1) {
      setSelectedCompoundIndex(0);
      return;
    }

    setSelectedCompoundIndex(selectedCompoundIndex + 1);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        justifyContent: { xs: 'space-between', md: 'flex-end' },
      }}
    >
      <BorderedButton
        sxProps={{
          alignItems: 'center',
          alignSelf: 'stretch',
          display: 'flex',
          justifyContent: 'center',
          lineHeight: '17px',
          marginLeft: '0px',
          marginTop: '12px',
          mb: 2,
          color: isSmallDevice
            ? theme.custom.report.details.compoundCardsList.compoundDetailsPagination.mobileBackButtonColor
            : theme.custom.report.details.compoundCardsList.compoundDetailsPagination.desktopBackButtonColor,
          '& .MuiButton-startIcon': {
            height: '18px',
            width: '18px',
            backgroundImage: `url(${isSmallDevice ? theme.custom.report.details.compoundCardsList.compoundDetailsPagination.default.mobileBackIcon : theme.custom.report.details.compoundCardsList.compoundDetailsPagination.default.desktopBackIcon})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
          },
          '&:hover': {
            background: 'transparent',
            color: theme.buttons.ghost.hover.color,
            border: '2px solid',
            '& .MuiButton-startIcon': {
              height: '18px',
              width: '18px',
              backgroundImage: `url(${isSmallDevice ? theme.custom.report.details.compoundCardsList.compoundDetailsPagination.hover.mobileBackIcon : theme.custom.report.details.compoundCardsList.compoundDetailsPagination.hover.desktopBackIcon})`,
              backgroundSize: 'contain',
            },
          },
        }}
        additionalProps={{
          style: { border: 'none', height: '18px' },
          startIcon: <></>,
        }}
        onClick={selectPreviousCompound}
        buttonText={isSmallDevice ? 'Previous compound' : 'Previous'}
      />

      {/* Next Button with Hover Icon Change */}
      <BorderedButton
        sxProps={{
          alignItems: 'center',
          alignSelf: 'stretch',
          display: 'flex',
          justifyContent: 'center',
          lineHeight: '17px',
          marginLeft: '0px',
          marginTop: '12px',
          mb: 2,
          color: isSmallDevice
            ? theme.custom.report.details.compoundCardsList.compoundDetailsPagination.mobileNextButtonColor
            : theme.custom.report.details.compoundCardsList.compoundDetailsPagination.desktopNextButtonColor,
          '& .MuiButton-endIcon': {
            height: '18px',
            width: '18px',
            backgroundImage: `url(${isSmallDevice ? theme.custom.report.details.compoundCardsList.compoundDetailsPagination.default.mobileNextIcon : theme.custom.report.details.compoundCardsList.compoundDetailsPagination.default.desktopNextIcon})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
          },
          '&:hover': {
            background: 'transparent',
            color: theme.buttons.ghost.hover.color,
            border: '2px solid',
            '& .MuiButton-endIcon': {
              height: '18px',
              width: '18px',
              backgroundImage: `url(${isSmallDevice ? theme.custom.report.details.compoundCardsList.compoundDetailsPagination.hover.mobileNextIcon : theme.custom.report.details.compoundCardsList.compoundDetailsPagination.hover.desktopNextIcon})`,
              backgroundSize: 'contain',
            },
          },
        }}
        additionalProps={{
          style: { border: 'none', height: '18px' },
          endIcon: <></>,
        }}
        onClick={selectNextCompound}
        buttonText={isSmallDevice ? 'Next compound' : 'Next'}
      />
    </Box>
  );
};
